import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

interface DpAutoHiddenProps {
	milliseconds?: number;
	children: React.ReactNode;
}

export const DpAutoHidden: React.FC<DpAutoHiddenProps> = ({ milliseconds = 3000, children }) => {
	const [isVisible, setIsVisible] = useState(true);
	const [isDisplayed, setIsDisplayed] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(false);
		}, milliseconds);
		return () => clearTimeout(timer);
	}, [milliseconds]);

	const handleAnimationComplete = () => {
		if (!isVisible) {
			setIsDisplayed(false);
		}
	};

	if (!isDisplayed) {
		return null;
	}

	return (
		<motion.div
			initial={{ opacity: 1, x: 0 }}
			animate={{ opacity: isVisible ? 1 : 0, x: isVisible ? 0 : 200 }}
			transition={{ duration: 0.5 }}
			onAnimationComplete={handleAnimationComplete}
		>
			{children}
		</motion.div>
	);
};

export default DpAutoHidden;
